import { openDB, type IDBPDatabase } from "idb";

// Browser-only secrets & engine flags. The Telegram StringSession lives ONLY here.
const DB_NAME = "tg-broadcast";
const STORE = "kv";

let dbp: Promise<IDBPDatabase> | null = null;
function db(): Promise<IDBPDatabase> {
  if (!dbp) {
    dbp = openDB(DB_NAME, 1, {
      upgrade(d) {
        if (!d.objectStoreNames.contains(STORE)) d.createObjectStore(STORE);
      },
    });
  }
  return dbp;
}

export async function kvGet<T>(key: string): Promise<T | undefined> {
  return (await db()).get(STORE, key) as Promise<T | undefined>;
}
export async function kvSet(key: string, value: unknown): Promise<void> {
  await (await db()).put(STORE, value, key);
}
export async function kvDel(key: string): Promise<void> {
  await (await db()).delete(STORE, key);
}

export const KEYS = {
  session: "tg.session",
  apiId: "tg.apiId",
  apiHash: "tg.apiHash",
  proxyEnabled: "tg.proxyEnabled",
  cooldownUntil: "tg.cooldownUntil",
  cupon: "tg.cupon", // last cupón builder config
  cuponLogo: "tg.cuponLogo", // uploaded Stake logo as data URL
} as const;
